import React from 'react';
import { lowerCase } from 'lodash';

import { UncontrolledTable, SimpleCollapse } from '~/components';
import usePatient from '~/utils/patient/hook';
import formatPhone from '~/utils/format/phone';
import { TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const filterMethod = (filter, row) =>
  lowerCase(row._original.attributes.firstname).includes(lowerCase(filter.value)) ||
    lowerCase(row._original.attributes.lastname).includes(lowerCase(filter.value));

const PrimaryCareProvider = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <React.Fragment>
      <UncontrolledTable
        name="primary-care-provider"
        defaultPageSize={1}
        showPaginationBottom={false}
        filterable={false}
        endpoint={{
          url: 'data/public/list-view-cs-tbl-primaryprovider',
          params: {
            distinct: 'lastname,firstname',
            sacwis_id: sacwisId,
            iscurrentpcp: 'current',
            match_status_id: MatchStatus.Approved,
            'effdateDt__!': 'null',
            page: 1,
            'page-size': 1,
          },
        }}
        defaultSorted={[{ id: 'effdateDt', desc: true }]}
        className="mx-4"
        columns={[
          {
            id: 'effdateDt',
            Header: 'Date Identified',
            accessor: 'attributes.effdateDt',
            cellType: 'date',
          },
          {
            id: 'sourceDescription',
            Header: 'Reporting Healthcare Institution',
            accessor: 'attributes.sourceDescription',
            Filter: d => <TableFilterIdentitySource {...d} />,
          },
          {
            id: 'lastname,firstname',
            Header: 'Name',
            accessor: 'attributes',
            Cell: d => <>{d.original.attributes.lastname}, {d.original.attributes.firstname}</>,
            filterMethod,
          },
          {
            id: 'phone',
            Header: 'Phone',
            accessor: d => (
              <>
                <a href={`tel:${d.attributes.phone}`}>
                  {formatPhone(d.attributes.phone)}
                </a>
              </>
            ),
          },
          {
            id: 'address',
            Header: 'Address',
            accessor: d => (
              <>
                <span>{d.attributes.address}</span>
                <br />
                <span>
                  {d.attributes.city} {d.attributes.state} {d.attributes.zip}
                </span>
              </>
            ),
          },
        ]}
      />

      <SimpleCollapse
        title="Previous PCPs"
        body={
          <UncontrolledTable
            name="primary-care-provider-history"
            endpoint={{
              url: 'data/public/list-view-cs-tbl-primaryprovider-recent',
              params: {
                sacwis_id: sacwisId,
                match_status_id: MatchStatus.Approved,
                iscurrentpcp: 'historical',
                'all-data': '1',
              },
            }}
            className="mt-2"
            defaultSorted={[{ id: 'effdateDt', desc: true }]}
            columns={[
              {
                id: 'effdateDt',
                Header: 'Date Identified',
                accessor: 'attributes.effdateDt',
                cellType: 'date',
              },
              {
                id: 'sourceDescription',
                Header: 'Reporting Healthcare Institution',
                accessor: 'attributes.sourceDescription',
                Filter: d => <TableFilterIdentitySource {...d} />,
              },
              {
                id: 'lastname,firstname',
                Header: 'Name',
                accessor: 'attributes',
                Cell: d => (
                  <>
                    {d.original.attributes.lastname}, {d.original.attributes.firstname}
                  </>
                ),
                filterMethod,
              },
              {
                id: 'phone',
                Header: 'Phone',
                accessor: d => (
                  <>
                    <a href={`tel:${d.attributes.phone}`}>
                      {formatPhone(d.attributes.phone)}
                    </a>
                  </>
                ),
              },
              {
                id: 'address',
                Header: 'Address',
                accessor: d => (
                  <>
                    <span>{d.attributes.address}</span>
                    <br />
                    <span>
                      {d.attributes.city} {d.attributes.state}{' '}
                      {d.attributes.zip}
                    </span>
                  </>
                ),
              },
            ]}
          />
        }
        className="mt-3"
      />
    </React.Fragment>
  );
};

export default PrimaryCareProvider;
